import store from '../store'

export default {
  publicRoute (to, from, next) {
    next()
  },
  maaStaff (to, from, next) {
    if (!store.getters.isAuthenticated) {
      next({path: '/login', params: { nextUrl: to.fullPath }})
    }
    if (!store.getters.hasMAAStaff) {
      if (store.getters.isBOD) {
        // if they're a BOD, send them to the dashboard.
        next({path: '/board-of-directors', params: { nextUrl: to.fullPath }})
      } else {
        next({path: '/login', params: { nextUrl: to.fullPath }})
      }
    }
    next()
  },
  administrator (to, from, next) {
    if (!store.getters.isAuthenticated) {
      next({path: '/login', params: { nextUrl: to.fullPath }})
    }
    if (!store.getters.hasAdministrator) {
      next({path: '/login', params: { nextUrl: to.fullPath }})
    }
    next()
  },
  superAdministrator (to, from, next) {
    if (!store.getters.isAuthenticated) {
      next({path: '/login', params: { nextUrl: to.fullPath }})
    }
    if (!store.getters.hasSuperAdministrator) {
      next({path: '/login', params: { nextUrl: to.fullPath }})
    }
    next()
  },
  isAccountType (to, from, next, isAccountType) {
    if (!store.getters.isAuthenticated) {
      return next({path: '/login', params: { nextUrl: to.fullPath }})
    }
    if (!isAccountType) {
      //  exception for board of directors
      if (store.getters.isBOD) {
        return next({path: '/board-of-directors', params: { nextUrl: to.fullPath }})
      }
      return next({path: '/login', params: { nextUrl: to.fullPath }})
    }
    return next()
  },
  hasCapability (to, from, next, isAccountType, hasCapabilityType) {
    if (!store.getters.isAuthenticated) {
      return next({path: '/login', params: { nextUrl: to.fullPath }})
    }
    if (!isAccountType) {
      return next({path: '/login', params: { nextUrl: to.fullPath }})
    }
    if (!hasCapabilityType) {
      return next({path: '/', params: { nextUrl: to.fullPath }})
    }
    return next()
  },
  isAccountTypeOrHasCapability (to, from, next, isAccountType, hasCapabilityType) {
    if (!store.getters.isAuthenticated) {
      return next({path: '/login', params: { nextUrl: to.fullPath }})
    }
    if (isAccountType || hasCapabilityType) {
      return next()
    }
    return next({path: '/', params: { nextUrl: to.fullPath }})
  }
}



// WEBPACK FOOTER //
// ./src/router/_RouterGuards.js